import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { RoutePropertyDefinitionItemMaintenanceDto } from './RoutePropertyDefinitionItemMaintenanceDto';
import { RoutePropertyDefinitionListMaintenanceDto } from './RoutePropertyDefinitionListMaintenanceDto';
import { Observable } from 'rxjs';

@Injectable()
export class RoutePropertyDefinitionMaintenanceController extends BaseMaintenanceController<RoutePropertyDefinitionListMaintenanceDto, RoutePropertyDefinitionItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "routepropertydefinition");
    }

    private base = '/maintenance/routepropertydefinition';

    public getResourceRoot(): string {
        return "ROUTEPROPERTYDEFINITION";
    }

    public buildUrl(uri: string): string {
        return "system/dataandparameters/routepropertydefinition" + uri;
    }
}
